import { DIALOG_DATA, DialogModule, DialogRef } from "@angular/cdk/dialog";
import { CommonModule, KeyValuePipe } from "@angular/common";
import { Component, Inject, LOCALE_ID } from "@angular/core";
import { CloudinaryModule, lazyload } from "@cloudinary/ng";
import { Cloudinary, CloudinaryImage } from "@cloudinary/url-gen";
import { scale } from "@cloudinary/url-gen/actions/resize";
import { DialogContainerComponent } from "src/app/dialogs/dialog-container/dialog-container.component";

type Locales = {
    [key: string]: {
        name: string;
        flag: string;
        slug: string;
    };
}

type Flags = {
    [key: string]: CloudinaryImage
}

@Component({
    selector: "app-locale-picker-dialog",
    templateUrl: "./locale-picker-dialog.component.html",
    standalone: true,
    imports: [CommonModule, CloudinaryModule, KeyValuePipe, DialogModule, DialogContainerComponent],
})
export class LocalePickerDialogComponent {
    public locales: Locales  = {};
    public flags: Flags = {};
    public plugins = [lazyload()];

    constructor(
        @Inject(DIALOG_DATA) public data: any,
        @Inject(LOCALE_ID) public currentLocale: string,
        public dialog: DialogRef<LocalePickerDialogComponent>
    ) {
        this.locales = data?.locales;
        const cld = new Cloudinary({ cloud: { cloudName: "minirobot" } });
        Object.keys(this.locales).forEach((locale) => {
            this.flags[locale] = cld.image(this.locales[locale]?.flag ?? this.locales["en"].flag);
            this.flags[locale].resize(scale().width(30));
        });
    }
    
    public close() {
        this.dialog.close();
    }
}
